import React from 'react';
import { Database, Eye } from 'lucide-react';
import { StatusTag } from './StatusTag';

export const DataContractCard = ({
  id,
  name,
  description,
  status,
  lastUpdated,
  dataSource,
  consumers,
  slaCompliance,
  dataQuality,
  freshness,
  onViewDetails
}) => {
  const getStatusBg = () => {
    switch (status) {
      case 'healthy':
        return 'from-green-50 to-green-100 border-green-200';
      case 'warning':
        return 'from-amber-50 to-amber-100 border-amber-200';
      case 'critical':
        return 'from-red-50 to-red-100 border-red-200';
      default:
        return '';
    }
  };

  return (
    <div className={`relative group bg-gradient-to-br ${getStatusBg()} backdrop-blur-sm border rounded-xl p-4 hover:shadow-xl transition-all duration-300 hover:scale-[1.02]`} style={{ width: '296px', height: '260px' }}>
      {/* Status Tag */}
      <div className="absolute top-4 right-4">
        <StatusTag status={status} animate={status === 'critical'} />
      </div>

      {/* Header */}
      <div className="mb-4 pr-20">
        <div className="flex items-center gap-2 mb-2">
          <Database className=" h-5 text-gray-600" />
          <h3 className="font-semibold text-gray-900 text-lg w-[100px]">{name}</h3>
        </div>
        <p 
          className="text-gray-600 text-sm leading-relaxed line-clamp-5"
          title={description}
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 5,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {description}
        </p>
      </div>

      {/* Metrics Grid - COMMENTED OUT */}
      {/* <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="space-y-3">
          <div>
            <div className="flex items-center gap-1 mb-1">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span className="text-xs font-medium text-gray-600">SLA Compliance</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex-1 bg-gray-200 rounded-full h-2">
                <div 
                  className={`h-2 rounded-full transition-all duration-500 ${
                    slaCompliance >= 95 ? 'bg-green-500' : 
                    slaCompliance >= 80 ? 'bg-amber-500' : 'bg-red-500'
                  }`}
                  style={{ width: `${slaCompliance}%` }}
                ></div>
              </div>
              <span className="text-xs font-bold text-gray-700">{slaCompliance}%</span>
            </div>
          </div>

          <div>
            <div className="flex items-center gap-1 mb-1">
              <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
              <span className="text-xs font-medium text-gray-600">Data Quality</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex-1 bg-gray-200 rounded-full h-2">
                <div 
                  className={`h-2 rounded-full transition-all duration-500 ${
                    dataQuality >= 95 ? 'bg-green-500' : 
                    dataQuality >= 80 ? 'bg-amber-500' : 'bg-red-500'
                  }`}
                  style={{ width: `${dataQuality}%` }}
                ></div>
              </div>
              <span className="text-xs font-bold text-gray-700">{dataQuality}%</span>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <Users className="w-4 h-4 text-gray-500" />
            <span className="text-xs text-gray-600">Consumers</span>
            <span className="text-xs font-bold text-gray-800 ml-auto">{consumers}</span>
          </div>

          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-gray-500" />
            <span className="text-xs text-gray-600">Freshness</span>
            <span className="text-xs font-bold text-gray-800 ml-auto">{freshness}</span>
          </div>
        </div>
      </div> */}

      {/* Footer */}
      <div className=" absolute bottom-2 right-1 pt-3 border-t border-white/50">
        <div className="flex items-end justify-end">
          {/* Source and Updated info - COMMENTED OUT */}
          {/* <div className="text-xs text-gray-500">
            <div>Source: {dataSource}</div>
            <div>Updated: {lastUpdated}</div>
          </div> */}
          <button
            onClick={onViewDetails}
            className="flex items-center gap-1 px-3 py-1.5 bg-white/80 hover:bg-white text-gray-700 hover:text-blue-600 rounded-lg transition-all duration-200 text-xs font-medium border border-white/50 hover:border-blue-200 hover:shadow-sm"
          >
            <Eye className=" h-3" />
            View Details
          </button>
        </div>
      </div>

      {/* Hover overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
    </div>
  );
};
